import axios from "axios";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Vue from "vue";
import VueAxios from "vue-axios";
import Vuelidate from "vuelidate";
import VueMask from 'v-mask'

import App from "./App.vue";
import { router } from "./router";
import store from './store';

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/index.css';

import Toasted from 'vue-toasted';

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas)

export const EventBus = new Vue();

Vue.use( BootstrapVue );
Vue.use( Vuelidate );
Vue.use(VueMask);
Vue.use( VueAxios,VueToast,Toasted );
Vue.use(require('vue-moment'));
// axios.create({ baseURL: process.env.VUE_APP_API_URL, withCredentials: true })

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
